import {
  TRANSPORT,
  MESSAGE,
} from '../actions/types';

const INITIAL_STATE = {
  transporter:null,
  message:'',
  parameter:null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TRANSPORT:

      return { ...state, ...action.payload };
      case MESSAGE:

          return { ...state, ...action.payload };
    default:
      return state;
  }
};
